import { EmptySetup } from "appworks/boot/empty-setup";
import { Services } from "appworks/services/services";
import { GamevyReelsetControlDebugger } from "gamevy/debug/gamevy-reelset-control-debugger";
import { GamevyIntegrationDebugger } from "gamevy/debug/integration-debugger/gamevy-integration-debugger";
import { gamevyForceLoader } from "gamevy/debug/menu/gamevy-force-loader";
import { gamevy } from "gamevy/gamevy";
import { gamevyModel } from "gamevy/gamevy-model";
import { gamevyOfflineHTTPConnector } from "gamevy/server/connectors/gamevy-offline-http-connector";
import { GamevyAutoplay } from "gamevy/services/gamevy-autoplay";
import { GamevyCurrency } from "gamevy/services/gamevy-currency";
import { GamevyTransaction } from "gamevy/services/gamevy-transaction";
import { DebuggerTab } from "slotworks/debug/menu/tabs/debugger-tab";

declare var window: any;
export class GamevyBackendSetup extends EmptySetup {
    public setupDebug() {
        DebuggerTab.IntegrationDebuggerType = GamevyIntegrationDebugger;
        DebuggerTab.ReelsetControlDebuggerType = GamevyReelsetControlDebugger;

        window.gamevy = gamevy;
        window.gamevyForceLoader = gamevyForceLoader;
        window.gamevyModel = gamevyModel;
        window.gamevyOfflineHTTPConnector = gamevyOfflineHTTPConnector;
    }

    public setupServices(): void {
        Services.TransactionType = GamevyTransaction;
        Services.AutoplayType = GamevyAutoplay;
        Services.CurrencyType = GamevyCurrency;
    }

    public onReady(): void {
        gamevy.onReady();
    }
}
